module.exports = __webpack_public_path__ + "static/media/caazam_w_tag.9c53f38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caazam_w_tag.png
// module id = 1159
// module chunks = 0